import StandaloneOnboarding from './standaloneOnboarding';

export default StandaloneOnboarding;
